import React from 'react';
import { Button } from './ui/button';
import { Separator } from './ui/separator';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    legal: [
      { name: 'Privacy Policy', href: '/privacy-policy' },
      { name: 'Terms of Service', href: '/terms-of-service' }
    ],
    support: [
      { name: 'Contact Us', href: '/contact' },
      { name: 'Help Center', href: '/help' },
      { name: 'Report Content', href: '/report' }
    ]
  };

  return (
    <footer className="bg-gray-900/95 border-t border-orange-500/20 mt-16">
      <div className="container mx-auto px-6 py-12">
        
        {/* Main Footer Content */}
        <div className="mb-8">
          
          {/* Centered Layout: Megavideosee, Legal, Support - Side by Side */}
          <div className="flex justify-center">
            <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-16">
              
              {/* Brand Section */}
              <div className="text-center">
                <div className="text-2xl font-bold text-white mb-3">
                  <span className="text-orange-400 font-black text-3xl">Mega</span><span className="text-white"videosee</span>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
                  The ultimate destination for premium adult entertainment. 
                  Discover thousands of high-quality videos, exclusive content, 
                  and the best viewing experience on the web.
                </p>
              </div>
              
              {/* Legal Section */}
              <div className="text-center">
                <h4 className="text-orange-400 font-semibold mb-4 text-sm uppercase tracking-wide">
                  Legal
                </h4>
                <ul className="space-y-2">
                  {footerLinks.legal.map((link) => (
                    <li key={link.name}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-400 hover:text-orange-400 text-sm transition-colors duration-300"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Support Links */}
              <div className="text-center">
                <h4 className="text-orange-400 font-semibold mb-4 text-sm uppercase tracking-wide">
                  Support
                </h4>
                <ul className="space-y-2">
                  {footerLinks.support.map((link) => (
                    <li key={link.name}>
                      <a
                        href={link.href}
                        className="text-gray-400 hover:text-orange-400 text-sm transition-colors duration-300"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <Separator className="bg-orange-500/20 mb-8" />

        {/* Adult Content Disclaimer */}
        <div className="mb-8">
          <div className="bg-orange-600/10 border border-orange-500/20 rounded-lg p-6">
            <h5 className="text-orange-400 font-semibold mb-3 text-sm uppercase tracking-wide">
              Age Restriction Notice
            </h5>
            <p className="text-gray-400 text-xs leading-relaxed">
              Megavideosee offers unlimited free porn videos featuring the hottest porn stars. 
              Enjoy full-length scenes from the best XXX studios, along with the largest amateur porn community on the web. 
              We update our porn videos daily to ensure you always have access to the highest quality sex movies.
            </p>
          </div>
        </div>

        <Separator className="bg-orange-500/20 mb-6" />

        {/* Bottom Section */}
        <div className="flex justify-center">
          {/* Copyright */}
          <div className="text-gray-500 text-sm">
            © Copyright {currentYear}, megavideosee.com - All Rights Reserved
          </div>
        </div>

        {/* Additional Legal Notice */}
        <div className="mt-6 pt-4 border-t border-gray-700">
          <p className="text-gray-600 text-xs text-center leading-relaxed">
            This website contains age-restricted materials including nudity and explicit depictions of sexual activity. 
            By entering, you affirm that you are at least 18 years of age or the age of majority in the jurisdiction 
            from which you are accessing the website and you consent to viewing sexually explicit content.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;